import {Routes} from '@angular/router';

export const compliantsClientRoutes: Routes = [
  { path: 'ethic', loadComponent: () => import('@compliants-client/pages/ethic/ethic').then(m => m.Ethic)},
  { path: 'policy', loadComponent: () => import('@compliants-client/pages/policy/policy').then(m => m.Policy)},
  { path: 'privacy', loadComponent: () => import('@compliants-client/pages/privacy/privacy').then(m => m.Privacy)},
  { path: 'faqs', loadComponent: () => import('@compliants-client/pages/faqs/faqs').then(m => m.Faqs)},
  { path: 'ticket', loadComponent: () => import('@compliants-client/pages/ticket/ticket').then(m => m.Ticket)},
];
